import React from "react";
import PositionList from "../PositionList";
import { hashHistory } from "react-router";
import NHeader from "../NHeader";
import NavigatorMain from "../NavigatorMain";
import './changefundlist.css'
import { connect } from "react-redux";
import { getChangeFundList, changeFundListDel } from '../../action/portfolioAction'

class ChangeFundList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  componentDidMount() {
    document.title = "调仓记录";
    this.props.dispatch(getChangeFundList({
      superFundCode: this.props.location.state.superFundCode
    }));
  }
  componentWillUnmount() {
    this.props.dispatch(changeFundListDel());
  }
  toDetail = (superFundCode, version) =>
    hashHistory.push({
      pathname: "/ChangeFundDetail",
      query: {
        superFundCode,
        version,
      },
      state: {
        superFundCode,
        version,
      },
    });
  header = (key) => {
    return <div className="CF_list_header">{key + "年"}</div>;
  };

  renderItem = (v) => {
    const arr = v.adjustDateStr.split("-");
    const adjustReason = v.adjustReason.length > 100 ? v.adjustReason.slice(0, 100) + "..." : v.adjustReason;
    return (
      <div key={v.version} className="CF_list_item" >
        <div className="CF_item_data">
          <span className="CF_item_day">{arr[2]}</span>
          <span className="CF_item_month">{arr[1] + "月"}</span>
        </div>
        <div className="CF_item_line">
        </div>
        <div className="CF_item_content" style={{ /*  paddingBottom: i != length - 1 && ".6rem"  */ }}>
          <div className="CF_item_con">
            <div className="CF_item_header" onClick={() => {
              this.toDetail(v.superFundCode, v.version);
            }}>
              <span className="CF_item_title">调仓理由</span>
              <div className="CF_item_detail_btn" >
                <span>详情</span>
                <img style={{ width: ".2rem" }} src={require("../../img/n_icon_arrow_gray@2x.png")} />
              </div>
            </div>
            <p>{adjustReason}</p>
          </div>
        </div>
      </div>
    );
  };
  render() {
    const { dataSource={} } = this.props;
    console.log('data',dataSource)
    return (
      <div className="CF_list_container" style={{ minHeight: window.winHeight }}>
        <NavigatorMain>
          <NHeader title="调仓记录" isPaddingBottom={0}/>
        </NavigatorMain>
        <div className="CF_list_content" style={dataSource && !Object.keys(dataSource).length ? { display: 'flex', alignItems: 'center', justifyContent: 'center' } : null}>
          {dataSource && !Object.keys(dataSource).length ?
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <img style={{ width: '4.14rem' }} src={require('../../imgs/icon_no_data.png')} />
              <span style={{ fontSize: '.28rem', lineHeight: '.4rem', color: '#333', marginTop: '.3rem' }}>这里空空如也～</span>
            </div> :
            Object.keys(dataSource).map((key) => (
              <PositionList key={key} header={this.header(key)} renderItem={this.renderItem} dataSource={dataSource[key]} />
            ))

          }
        </div>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    dataSource: state.changeFundList.processedData
  };
}
export default connect(mapStateToProps)(ChangeFundList);



// WEBPACK FOOTER //
// ./src/components/fundDetail/ChangeFundList.js